import { useCallback } from "react";
import { isReservationPayment, isFinalSettlementPayment } from "../../../../../services/agreementsService";
import { PaymentCard } from "./PaymentCard";

export const PaymentsList = (props) => {
    const {
        payments,
        setPayments,
        includesReservationPayment,
        investmentId,
        products,
        productDiscounts,
        readonly = false,
    } = props;

    const handleDeletePayment = useCallback(
        (idx) => {
            const updatedPayments = payments.filter((_, index) => index !== idx);
            setPayments(updatedPayments);
        },
        [payments, setPayments],
    );

    const handleSetPayment = useCallback(
        (updatedPayment, idx) => {
            const updatedPayments = payments.map((payment, index) =>
                index === idx ? updatedPayment : payment,
            );
            setPayments(updatedPayments);
        },
        [payments, setPayments],
    );

    return (
        <>
            {payments.filter(payment=>!isFinalSettlementPayment(payment)).map((payment, idx) => {
                const isThisReservation = isReservationPayment(payment);
                const trancheNumber = includesReservationPayment ? idx : idx + 1;
                return (
                    <PaymentCard
                        key={idx}
                        idx={isThisReservation ? 0 :  trancheNumber}
                        payment={payment}
                        setPayment={(updatedPayment) => handleSetPayment(updatedPayment, idx)}
                        onDelete={() => handleDeletePayment(idx)}
                        investmentId={investmentId}
                        products={products}
                        productDiscounts={productDiscounts}
                        allPayments={payments}
                        readonly={readonly}
                    />
                );
            })}
            {payments.filter(payment=>isFinalSettlementPayment(payment)).map((payment, idx) => {
                return (
                    <PaymentCard
                        key={payments.length-1}
                        idx={payments.length-1}
                        payment={payment}
                        setPayment={(updatedPayment) => handleSetPayment(updatedPayment, payments.length-1)}
                        onDelete={() => {}}
                        investmentId={investmentId}
                        products={products}
                        productDiscounts={productDiscounts}
                        allPayments={payments}
                        readonly={readonly}
                    />
                );
            })}
        </>
    );
};
